import { useRouteParams } from '../hooks/useRouteParams';
import { downloadFile } from '../../CommonUtils/downloadFile';
import { toast } from '../../CommonComponents/OPL/Toast/Toast';
import { useDownloadFolderMutation } from '../api/useDownloadFolderMutation';
import { EntityDTO, EntityTypeDTO } from '../DocumentVault.meta';

const withZipExtension = (name: string): string =>
  name.toLowerCase().endsWith('.zip') ? name : `${name}.zip`;

interface UseDownloadFolderResultProps {
  isDownloadingFolder: boolean;
  actions: {
    onEntityDownload(entity: EntityDTO): void;
  };
}

export const useDownloadFolder = (): UseDownloadFolderResultProps => {
  const { clientId } = useRouteParams();

  const {
    mutateAsync: downloadFolderBlob,
    isLoading: isDownloadingFolder,
  } = useDownloadFolderMutation();

  const onEntityDownload = async (entity: EntityDTO) => {
    switch (entity.type) {
      case EntityTypeDTO.Folder:
        try {
          const { fileName, fileBlob } = await downloadFolderBlob({
            clientId,
            path: entity.path,
            providerType: entity.providerType,
          });

          return downloadFile(fileName || withZipExtension(entity.name), fileBlob);
        } catch (err) {
          console.error(err);
          throw err;
        }

      default:
        return toast.error('The selected entity type is not supported.');
    }
  };

  return {
    isDownloadingFolder,
    actions: { onEntityDownload },
  };
};
